import { useCallback } from 'react';
import { useNavigate, type NavigateOptions, type To } from 'react-router-dom';

interface ViewTransitionDocument extends Document {
  startViewTransition?: (cb: () => void | Promise<void>) => {
    finished: Promise<void>;
    ready: Promise<void>;
    updateCallbackDone: Promise<void>;
  };
}

/**
 * Замена useNavigate() с поддержкой View Transitions API.
 * Если браузер поддерживает — навигация анимируется автоматически.
 * Если нет — обычная навигация, без отличий.
 */
export function useViewTransition() {
  const navigate = useNavigate();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      const doc = document as ViewTransitionDocument;

      const doNavigate = () => {
        if (typeof to === 'number') {
          navigate(to);
        } else {
          navigate(to, options);
        }
      };

      if (doc.startViewTransition) {
        doc.startViewTransition(() => {
          doNavigate();
        });
      } else {
        doNavigate();
      }
    },
    [navigate],
  );
}